import { Bot } from "lucide-react";
import { cn } from "../../lib/utils";

/**
 * Marks a principal that is software, not a person.
 *
 * Agents appear wherever people do — rosters, assignee pickers, comment
 * authors — because work genuinely can be handed to them. What must never
 * happen is mistaking one for a colleague, so the badge travels with the name
 * rather than being implied by an avatar someone has to recognise.
 */
export function AgentBadge({
  className,
  label = "Bot",
}: {
  className?: string;
  label?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex h-4 shrink-0 items-center gap-0.5 rounded-xs bg-accent-subtle px-1",
        "text-xs font-medium uppercase leading-none tracking-wide text-accent-text",
        className,
      )}
    >
      <Bot aria-hidden="true" className="size-2.5" />
      {label}
    </span>
  );
}
